import $ from 'jquery'
import { getEvidentlyFeatures } from '~/evidentlyFeatureFlags'
import { EVIDENTLY_FLAG } from './constants/keys'

export const arabicId = 'ar'

export const rtlLanguages = [arabicId, 'he', 'ug']
const RTL_CONTAINER_ID = 'body[root]'
const NAVBAR_ID = '#react-navbar'
type STLYE_POSITIONS = 'right' | 'left'

export const verifyLanguageLayout = (language?: string): void => {
  getEvidentlyFeatures().then((flags) => {
    if (flags && flags[EVIDENTLY_FLAG.RTL_CONFIG] && language) {
      if (rtlLanguages.includes(language)) {
        $(RTL_CONTAINER_ID).attr('dir', 'rtl')
        // Temporary fix while the home-team supports RTL navbar
        $(NAVBAR_ID).attr('dir', 'ltr')
      } else {
        $(RTL_CONTAINER_ID).attr('dir', 'lft')
      }
    }
  })
}

/**
 * This function returns the style position of the toolbar according to the language.
 * It's useful when we need to define a position (from css):
 * Example: `{ float: stylePositionByLanguage() }`
 * @param {string} language
 * @returns 'right' if language is rtl, 'left' if language is ltr
 */
export const stylePositionByLanguage = (
  language?: string
): Promise<STLYE_POSITIONS> => {
  return getEvidentlyFeatures().then((flags) => {
    if (flags && flags[EVIDENTLY_FLAG.RTL_CONFIG] && language) {
      if (rtlLanguages.includes(language)) {
        return 'right'
      } else {
        return 'left'
      }
    } else {
      return 'left'
    }
  })
}

export const isRTLLanguage = (language: string): boolean =>
  rtlLanguages.includes(language)
